exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "body{margin:0;overflow:hidden}.videoPlayer{position:relative;padding-top:calc(100% / 16 * 9 + 25px);font-family:Open Sans,sans-serif}.videoPlayer.barker:not(.float){padding-top:0;height:100%}", ""]);

